import { Injectable } from '@angular/core';

import { InAppBrowser , InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { Platform } from '@ionic/angular';
import { DataService } from './data.service';
import { SharedGlobals } from './shared-globals.service';

declare var cordova: any;

@Injectable({
  providedIn: 'root'
})
export class AppWebBrowser {

  options : InAppBrowserOptions = {
    location : 'yes',//Or 'no' 
    hideurlbar: 'yes',
    hidden : 'no', //Or  'yes'
    //clearcache : 'yes',
    //clearsessioncache : 'yes',
    zoom : 'no',//Android only ,shows browser zoom controls 
    hardwareback : 'yes',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Close', //iOS only
    closebuttoncolor: '#d3d3d3',
    toolbarcolor: '#000000',
    disallowoverscroll : 'yes', //iOS only 
    toolbar : 'yes', 
    toolbarposition : 'top', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'fullscreen',//iOS only 
    fullscreen : 'yes',//Windows only    
};

browser2: any = false;

constructor(private theInAppBrowser: InAppBrowser, public platform: Platform, public dataService: DataService, public sharedGlobals: SharedGlobals) {
}

openWithInAppBrowser(url : string){

    if(this.sharedGlobals.webVersion === true) {
        this.dataService.presentAlertNotNative()
        return
    }

    this.options.closebuttoncaption = this.dataService.getLang('Close');

    if (this.platform.is('android')) { 
	this.options.location = 'yes';
    }


    let target = "_blank";
    
    if(url.substr(-4).toLowerCase() == '.pdf') {
        console.log('open system browser');
        target = "_system"; // open in external browser
    }
    
    var browser = this.theInAppBrowser.create(url,target,this.options);
    browser.insertCSS ({
            code: "body.home {margin-top: 0;} #nav-wrapper {display:none;} img {max-width:100%;} html {background: #fff;}"
        });
     
    /** 
    // If we run this in the browser without this if statement we get an error
    if (typeof cordova !== 'undefined') { 
    
        //Events: loadstart, loadstop, loaderror, exit
        browser.on('exit').subscribe(() => {
        this.menuCtrl.open('left'); //reopen menu - not needed anymore
        });
        
    } 
    **/
 
}




openWithInAppBrowserUserProfile(url : string){

    this.options.closebuttoncaption = this.dataService.getLang('Close');

    if (this.platform.is('android')) { 
	this.options.location = 'yes';
    }


    
    
    let target = '_blank';
    this.browser2 = this.theInAppBrowser.create(url,target,this.options);
    this.browser2.insertCSS ({
            code: "body.home {margin-top: 0;} #nav-wrapper {display:none;} img {max-width:100%;} html {background: #fff;}"
        });
        
     
     if (typeof cordova !== 'undefined') { 
        this.browser2.on('loadstop').subscribe((event) => {
        
            var curUrl = event.url;
            curUrl = this.getCleanPathFromUrl(curUrl);
            
            var isUserPage = false;
            if (curUrl.indexOf("/user/") > -1) {
                isUserPage = true;
            }
            else if (curUrl.indexOf("/userlogin/") > -1) {
                this.sharedGlobals.curLoggedUser = '';
                this.dataService.addCurUserToStorage('');
            }
            
            var urlEnding = this.getLastComponentFromUrlString(curUrl);
            
            if(urlEnding === 'userexit') {
                this.browser2.close();
                console.log('USER EXIT');
            }
            else if(urlEnding === 'loggedout') {
                this.browser2.close();
                this.sharedGlobals.curLoggedUser = '';
                this.dataService.addCurUserToStorage('');
            }
            else if (isUserPage) {
                this.sharedGlobals.curLoggedUser = urlEnding; 
                this.dataService.addCurUserToStorage(urlEnding);
            }
 
        });
        
        }
        
}



openWithSystemBrowser(url : string){

    let target = "_system";    
    var browser = this.theInAppBrowser.create(url,target,this.options);
 
}




getCleanPathFromUrl(url : string) {
  //remove potential queryvars and #
  return url.split(/[?#]/)[0];
}

getLastComponentFromUrlString(url : string) {
  return url.match(/([^\/]*)\/*$/)[1]; // regex split last part of string, works also if last char is "/"
}





}
